import { PAGE_TYPES } from '../shared/utils/analytics/constants'

export const microPrefix = 'nol-portal-product'

export function getPageType(slug) {
	if (slug === '/productos/tiendas/') return PAGE_TYPES.DISTRIBUTOR

	const pathSegments = slug
		.split('/')
		.filter(segment => segment !== '' && segment !== microPrefix)

	if (pathSegments.length === 2) return PAGE_TYPES.PRODUCT_OVERVIEW
	if (pathSegments.length === 3) return PAGE_TYPES.PRODUCT_CATEGORY
	if (pathSegments.length === 4) return PAGE_TYPES.PRODUCT_DETAIL_PAGE

	return PAGE_TYPES.GENERIC
}
